import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {
  paymentGoalsPath: () => 'api/netPaymentGoals',
  paymentGoalPathById: (id) => `api/netPaymentGoals/${id}`,
  paymentGoalAuditsPathById: (id, params) => `/api/netPaymentGoals/${id}/Audits${getQueryParams(params)}`,
  paymentGoalAuditPropertiesPathById: (id) => `/api/netPaymentGoals/${id}/Audits/Properties`,
  paymentGoalAuditUsersPathById: (id) => `/api/netPaymentGoals/${id}/Audits/Users`,
};

export const getPaymentGoals = (params) =>
  makeRequest(authFetch.get(`${routes.paymentGoalsPath()}${getQueryParams(params)}`));

export const getPaymentGoalById = (id) => makeRequest(authFetch.get(routes.paymentGoalPathById(id)));

export const postPaymentGoal = (paymentGoal) => makeRequest(authFetch.post(routes.paymentGoalsPath(), paymentGoal));

export const updatePaymentGoal = (paymentGoal) => makeRequest(authFetch.put(routes.paymentGoalsPath(), paymentGoal));

export const deletePaymentGoal = (id) => makeRequest(authFetch.delete(routes.paymentGoalPathById(id)));

export const getPaymentGoalAudits = (id, params) =>
  makeRequest(authFetch.get(routes.paymentGoalAuditsPathById(id, params)));

export const getPaymentGoalAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.paymentGoalAuditPropertiesPathById(id)));

export const getPaymentGoalAuditUsers = (id) => makeRequest(authFetch.get(routes.paymentGoalAuditUsersPathById(id)));
